import { variables } from '..';
import { styled } from '@mui/material';

export function FieldRequiredIndicator() {
  return <Spa>*</Spa>;
}

const Spa = styled('span')(() => ({ color: variables.brandDanger }));
